module.exports = __webpack_public_path__ + "static/media/TitleScreen00.d33afb68.png";